import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgbcl-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
})
export class PreviewComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
